import React from "react";
import styles from "./AssistantTextMessage.module.css";
import {ChatHistoryDTO, WidgetAppearanceLocaleVariantUi} from "../../../../../../../../api/generated";
import {MessageTime} from "../../messageTime/MessageTime";
import {TextInMarkdown} from "../../../../../../../elements/textInMarkdown/TextInMarkdown";

interface AssistantTextMessageProps {
    chatHistory: ChatHistoryDTO
    widgetAppearanceSettings: WidgetAppearanceLocaleVariantUi
}

export const AssistantTextMessage: React.FC<AssistantTextMessageProps> = ({
                                                                              chatHistory,
                                                                              widgetAppearanceSettings
                                                                          }) => {
    return <div key={chatHistory.id} className={styles.wrapper}>
        <MessageTime timestamp={chatHistory.timestamp}/>
        <span className={styles.messageContent} style={{backgroundColor: widgetAppearanceSettings.brandColour}}>
            <TextInMarkdown text={chatHistory.message}/>
        </span>
    </div>
}
